import React, { useEffect, useState } from "react";
import UpperFooterSlider from "../../../Layout/Upper Footer Slider/UpperFooterSlider";
import { Link, useParams } from "react-router-dom";
import { GetService, PostService } from "../../../../Services/ConstantService";
import { API_URL } from "../../../../Services/ApiService";
import { BounceLoader } from "react-spinners";

export default function ProductDetails() {
  const params = useParams();
  const [ProductDetail, setProductDetail] = useState([]);
  const [Loading, setLoading] = useState(false);

  useEffect(() => {
    GetProductDetails();
  }, [params]);

  function GetProductDetails() {
    setLoading(true);
    GetService(`${API_URL?.GET_PRUDUCT_DETAIL}?id=${params?.id}`).then(
      (res) => {
        console.log(res);
        if (res?.data?.status) {
          setProductDetail(res?.data?.data);
        }
        setLoading(false);
      },
    );
  }

  return (
    <div className="Gallery-Wraps-2 retouching Canvases">
      <main>
        {/* hera banner start */}
        <div
          className="tp-breadcrumb__area fix tp-breadcrumb-height"
          data-background="assets/img/breadcrumb/Canvases.png"
          style={{
            backgroundImage: 'url("assets/img/breadcrumb/Canvases.png")',
          }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="tp-breadcrumb__content text-center z-index-5">
                  <h3 className="tp-breadcrumb__title">
                    {ProductDetail?.product_title} <br />
                  </h3>
                  <p className="w-100 b-heading">
                    {ProductDetail?.description}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* hero banner end */}
        {/* second content section start*/}
        <section className="parent">
          <section
            className=" pb-100 Partener photographs"
            data-background="assets/img/breadcrumb/routing.png"
            style={{
              backgroundSize: "cover",
              backgroundImage: "url('assets/img/breadcrumb/routing.png')",
            }}
          >
            <div className="container">
              <div className="row ">
                <div className="row text text-center  ">
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center ">
                    {/* <h4 className="text-left second">
                  Canvas Print
                  </h4> */}
                  </div>
                </div>
                <div
                  className="col-xl-8 col-lg-12 col-md-12 text-center m-auto pt-30"
                  style={{ zIndex: 9 }}
                >
                  <div className=" ">
                    <img
                      className="w-32"
                      src={ProductDetail?.product_image}
                      alt=""
                    />
                  </div>
                </div>
                <div className="text-center mt-60 button-uper">
                  <Link
                    to={"/create-custom-print"}
                    className="  large head banner"
                  >
                    Create {ProductDetail?.product_title}
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </section>
        {/* second content section end */}

        {ProductDetail?.product_title === "Print On Wood" && (
          <div className="wood">
            {/* catagori-area-start */}
            <div className="tp-catagori-2__area p-relative">
              <div className="container text-center pt-10 ">
                <div className="row text">
                  <div className="col-xl-12 col-lg-12 col-md-12">
                    <h4 className="text-left second">
                      What sets a wood print{" "}
                      <span className="color-inner">apart?</span>
                    </h4>
                    <p>
                      Wood prints bring a natural warmth and unique character to
                      your favorite photographs. The beautiful wood grain, rich
                      colors, and premium finish create a one-of-a-kind piece of
                      artwork that adds a timeless touch to any space.
                    </p>
                  </div>
                </div>
              </div>
              <div className="tp-catagori-2__wrapper-box p-relative">
                {/* <div class="tp-catagori-2__shape-2 d-none d-xxl-block">
              <img src="assets/img/catagori/shape-2-2.png" alt="">
          </div> */}
                <div className="container pb-80">
                  <div className="row">
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                      <div className="tp-catagori-2__content-box ">
                        <div className="tp-catagori-2__content plr text-center">
                          <svg
                            width={80}
                            height={80}
                            viewBox="0 0 80 80"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_1_8147)">
                              <path
                                d="M78.8226 26.8516C78.7159 25.2068 76.4032 25.1141 76.1535 26.729C74.9785 35.1023 75.5162 43.6477 75.3029 52.0518C68.6352 44.2127 60.5882 37.4643 54.4332 29.2019C54.2289 28.9786 53.9442 28.8457 53.6419 28.8322C53.3395 28.8188 53.0442 28.9261 52.8209 29.1304C43.5917 37.5708 38.2585 49.2476 30.1337 58.6301C27.5974 55.6499 25.0242 52.6958 22.3351 49.8258C21.7773 49.1541 20.7137 49.1458 20.1574 49.824C17.6846 52.7826 15.4273 56.0279 13.1942 59.1618C12.4263 60.2974 13.9749 61.4924 14.8792 60.4677C16.6848 58.3191 19.0996 55.303 21.1823 52.9948C27.0398 60.126 32.3388 67.7357 38.1032 74.9712C28.1698 75.5648 18.2221 76.461 8.30962 75.5482C4.52259 74.7579 3.01759 70.9607 3.23853 67.4093C3.11728 62.2296 3.54212 57.1037 3.67166 51.9184C4.29119 51.5437 4.73931 50.8679 4.73916 49.8796C4.56119 42.0002 3.98587 34.0568 3.83728 26.1824C1.95041 15.4879 9.53791 11.9941 18.8627 14.3144C21.1596 14.3829 21.3835 11.1166 19.1059 10.8651C7.96072 9.35116 -1.12834 13.8246 0.488688 26.3583C0.293219 33.1051 0.476031 42.3718 0.00243768 49.7905C-0.0363123 50.7766 0.390875 51.471 1.00181 51.8698C0.864313 56.7244 0.356656 61.6062 0.398063 66.4862C-0.143969 71.8458 2.13634 77.543 7.95744 78.6344C22.0363 80.0423 36.2163 79.2373 50.3207 79.2674C59.399 79.4458 70.0907 79.7079 77.5018 73.604C78.7249 72.4591 77.2809 70.6251 75.8959 71.4683C68.1966 75.6058 58.9965 74.6552 50.5262 74.5399C48.3323 74.534 46.1368 74.5858 43.9401 74.673C39.7884 70.1497 35.846 65.3858 31.8809 60.6921C39.6559 51.9783 44.8851 41.3016 53.2818 33.1305C58.427 39.8901 64.4071 46.1115 69.8302 52.6271C71.6771 54.8766 73.7338 57.4899 75.4021 59.8785C76.6852 61.664 79.552 60.8679 79.7129 58.6515C80.622 48.2179 79.106 37.2794 78.8226 26.8516Z"
                                fill="#444444"
                              />
                              <path
                                d="M21.4303 39.5086C33.2915 40.412 33.1645 22.0348 21.5065 22.2528C10.8434 22.4519 10.9433 38.7992 21.4303 39.5086ZM16.137 31.0848C16.5448 24.7714 27.298 26.1778 26.6289 32.2636C26.6261 32.3944 26.5922 32.6531 26.5626 32.7806C25.3658 38.895 15.6787 37.1311 16.137 31.0848ZM53.7867 15.8903C57.4128 16.3861 61.0415 18.3953 62.7853 21.6786C63.2647 22.9941 63.7065 24.2623 64.0089 25.4953C64.519 28.1773 68.6314 27.7547 68.5303 24.9805C68.492 23.8189 68.7108 22.6473 69.1698 21.5344C70.6145 18.0694 74.0851 15.4734 77.7764 14.8197C80.0648 14.472 79.9515 11.2122 77.6331 11.0394C69.4951 10.6403 70.2169 2.18796 66.568 0.586246C64.7397 0.0229647 63.7773 3.86984 62.6992 5.00812C60.6995 8.31828 57.7383 10.8805 53.7745 11.2737C51.1258 11.7089 51.112 15.4583 53.7867 15.8903ZM66.6161 4.73859C68.0425 8.02312 70.0398 11.4723 73.4955 13.0152C70.5083 14.3214 67.9212 16.6045 66.3465 19.4736C65.1559 16.9152 63.1445 14.8544 60.7381 13.4206C63.5286 11.3942 65.3583 8.3589 66.6161 4.73859ZM31.2975 9.66171C33.637 10.047 35.5345 11.2725 35.6503 13.7248C35.7281 14.1102 36.0389 14.4605 36.4601 14.4672C38.0497 14.2142 37.6712 11.6406 38.7075 10.6905C39.2203 9.91906 43.2897 9.30281 42.0067 7.9839C40.9869 7.505 39.8231 7.22703 39.072 6.425C38.3687 5.68765 37.9789 4.30984 37.6983 3.48625C37.4258 2.4589 35.9419 2.42968 35.7001 3.48671C35.1244 5.70593 34.2094 6.66343 32.01 7.29593C31.3928 7.5025 30.5876 7.5914 30.4355 8.37453C30.3108 8.96828 30.7014 9.55 31.2975 9.66171Z"
                                fill="#444444"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1_8147">
                                <rect width={80} height={80} fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <h4 className="tp-catagori-2__title text-white">
                            Natural Wood Texture
                          </h4>
                          <p className="mb-0">
                            Every wood print features unique grain patterns that
                            add warmth, character, and a natural feel to your
                            favorite photographs.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                      <div className="tp-catagori-2__content-box ">
                        <div className="tp-catagori-2__content plr text-center">
                          <svg
                            width={80}
                            height={80}
                            viewBox="0 0 80 80"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_1_8147)">
                              <path
                                d="M78.8226 26.8516C78.7159 25.2068 76.4032 25.1141 76.1535 26.729C74.9785 35.1023 75.5162 43.6477 75.3029 52.0518C68.6352 44.2127 60.5882 37.4643 54.4332 29.2019C54.2289 28.9786 53.9442 28.8457 53.6419 28.8322C53.3395 28.8188 53.0442 28.9261 52.8209 29.1304C43.5917 37.5708 38.2585 49.2476 30.1337 58.6301C27.5974 55.6499 25.0242 52.6958 22.3351 49.8258C21.7773 49.1541 20.7137 49.1458 20.1574 49.824C17.6846 52.7826 15.4273 56.0279 13.1942 59.1618C12.4263 60.2974 13.9749 61.4924 14.8792 60.4677C16.6848 58.3191 19.0996 55.303 21.1823 52.9948C27.0398 60.126 32.3388 67.7357 38.1032 74.9712C28.1698 75.5648 18.2221 76.461 8.30962 75.5482C4.52259 74.7579 3.01759 70.9607 3.23853 67.4093C3.11728 62.2296 3.54212 57.1037 3.67166 51.9184C4.29119 51.5437 4.73931 50.8679 4.73916 49.8796C4.56119 42.0002 3.98587 34.0568 3.83728 26.1824C1.95041 15.4879 9.53791 11.9941 18.8627 14.3144C21.1596 14.3829 21.3835 11.1166 19.1059 10.8651C7.96072 9.35116 -1.12834 13.8246 0.488688 26.3583C0.293219 33.1051 0.476031 42.3718 0.00243768 49.7905C-0.0363123 50.7766 0.390875 51.471 1.00181 51.8698C0.864313 56.7244 0.356656 61.6062 0.398063 66.4862C-0.143969 71.8458 2.13634 77.543 7.95744 78.6344C22.0363 80.0423 36.2163 79.2373 50.3207 79.2674C59.399 79.4458 70.0907 79.7079 77.5018 73.604C78.7249 72.4591 77.2809 70.6251 75.8959 71.4683C68.1966 75.6058 58.9965 74.6552 50.5262 74.5399C48.3323 74.534 46.1368 74.5858 43.9401 74.673C39.7884 70.1497 35.846 65.3858 31.8809 60.6921C39.6559 51.9783 44.8851 41.3016 53.2818 33.1305C58.427 39.8901 64.4071 46.1115 69.8302 52.6271C71.6771 54.8766 73.7338 57.4899 75.4021 59.8785C76.6852 61.664 79.552 60.8679 79.7129 58.6515C80.622 48.2179 79.106 37.2794 78.8226 26.8516Z"
                                fill="#444444"
                              />
                              <path
                                d="M21.4303 39.5086C33.2915 40.412 33.1645 22.0348 21.5065 22.2528C10.8434 22.4519 10.9433 38.7992 21.4303 39.5086ZM16.137 31.0848C16.5448 24.7714 27.298 26.1778 26.6289 32.2636C26.6261 32.3944 26.5922 32.6531 26.5626 32.7806C25.3658 38.895 15.6787 37.1311 16.137 31.0848ZM53.7867 15.8903C57.4128 16.3861 61.0415 18.3953 62.7853 21.6786C63.2647 22.9941 63.7065 24.2623 64.0089 25.4953C64.519 28.1773 68.6314 27.7547 68.5303 24.9805C68.492 23.8189 68.7108 22.6473 69.1698 21.5344C70.6145 18.0694 74.0851 15.4734 77.7764 14.8197C80.0648 14.472 79.9515 11.2122 77.6331 11.0394C69.4951 10.6403 70.2169 2.18796 66.568 0.586246C64.7397 0.0229647 63.7773 3.86984 62.6992 5.00812C60.6995 8.31828 57.7383 10.8805 53.7745 11.2737C51.1258 11.7089 51.112 15.4583 53.7867 15.8903ZM66.6161 4.73859C68.0425 8.02312 70.0398 11.4723 73.4955 13.0152C70.5083 14.3214 67.9212 16.6045 66.3465 19.4736C65.1559 16.9152 63.1445 14.8544 60.7381 13.4206C63.5286 11.3942 65.3583 8.3589 66.6161 4.73859ZM31.2975 9.66171C33.637 10.047 35.5345 11.2725 35.6503 13.7248C35.7281 14.1102 36.0389 14.4605 36.4601 14.4672C38.0497 14.2142 37.6712 11.6406 38.7075 10.6905C39.2203 9.91906 43.2897 9.30281 42.0067 7.9839C40.9869 7.505 39.8231 7.22703 39.072 6.425C38.3687 5.68765 37.9789 4.30984 37.6983 3.48625C37.4258 2.4589 35.9419 2.42968 35.7001 3.48671C35.1244 5.70593 34.2094 6.66343 32.01 7.29593C31.3928 7.5025 30.5876 7.5914 30.4355 8.37453C30.3108 8.96828 30.7014 9.55 31.2975 9.66171Z"
                                fill="#444444"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1_8147">
                                <rect width={80} height={80} fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <h4 className="tp-catagori-2__title text-white">
                            Rich Colors & Fine Details
                          </h4>
                          <p className="mb-0">
                            Advanced printing technology preserves vibrant
                            colors and sharp details, bringing your images to
                            life with stunning clarity.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                      <div className="tp-catagori-2__content-box ">
                        <div className="tp-catagori-2__content plr text-center">
                          <svg
                            width={80}
                            height={80}
                            viewBox="0 0 80 80"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_1_8147)">
                              <path
                                d="M78.8226 26.8516C78.7159 25.2068 76.4032 25.1141 76.1535 26.729C74.9785 35.1023 75.5162 43.6477 75.3029 52.0518C68.6352 44.2127 60.5882 37.4643 54.4332 29.2019C54.2289 28.9786 53.9442 28.8457 53.6419 28.8322C53.3395 28.8188 53.0442 28.9261 52.8209 29.1304C43.5917 37.5708 38.2585 49.2476 30.1337 58.6301C27.5974 55.6499 25.0242 52.6958 22.3351 49.8258C21.7773 49.1541 20.7137 49.1458 20.1574 49.824C17.6846 52.7826 15.4273 56.0279 13.1942 59.1618C12.4263 60.2974 13.9749 61.4924 14.8792 60.4677C16.6848 58.3191 19.0996 55.303 21.1823 52.9948C27.0398 60.126 32.3388 67.7357 38.1032 74.9712C28.1698 75.5648 18.2221 76.461 8.30962 75.5482C4.52259 74.7579 3.01759 70.9607 3.23853 67.4093C3.11728 62.2296 3.54212 57.1037 3.67166 51.9184C4.29119 51.5437 4.73931 50.8679 4.73916 49.8796C4.56119 42.0002 3.98587 34.0568 3.83728 26.1824C1.95041 15.4879 9.53791 11.9941 18.8627 14.3144C21.1596 14.3829 21.3835 11.1166 19.1059 10.8651C7.96072 9.35116 -1.12834 13.8246 0.488688 26.3583C0.293219 33.1051 0.476031 42.3718 0.00243768 49.7905C-0.0363123 50.7766 0.390875 51.471 1.00181 51.8698C0.864313 56.7244 0.356656 61.6062 0.398063 66.4862C-0.143969 71.8458 2.13634 77.543 7.95744 78.6344C22.0363 80.0423 36.2163 79.2373 50.3207 79.2674C59.399 79.4458 70.0907 79.7079 77.5018 73.604C78.7249 72.4591 77.2809 70.6251 75.8959 71.4683C68.1966 75.6058 58.9965 74.6552 50.5262 74.5399C48.3323 74.534 46.1368 74.5858 43.9401 74.673C39.7884 70.1497 35.846 65.3858 31.8809 60.6921C39.6559 51.9783 44.8851 41.3016 53.2818 33.1305C58.427 39.8901 64.4071 46.1115 69.8302 52.6271C71.6771 54.8766 73.7338 57.4899 75.4021 59.8785C76.6852 61.664 79.552 60.8679 79.7129 58.6515C80.622 48.2179 79.106 37.2794 78.8226 26.8516Z"
                                fill="#444444"
                              />
                              <path
                                d="M21.4303 39.5086C33.2915 40.412 33.1645 22.0348 21.5065 22.2528C10.8434 22.4519 10.9433 38.7992 21.4303 39.5086ZM16.137 31.0848C16.5448 24.7714 27.298 26.1778 26.6289 32.2636C26.6261 32.3944 26.5922 32.6531 26.5626 32.7806C25.3658 38.895 15.6787 37.1311 16.137 31.0848ZM53.7867 15.8903C57.4128 16.3861 61.0415 18.3953 62.7853 21.6786C63.2647 22.9941 63.7065 24.2623 64.0089 25.4953C64.519 28.1773 68.6314 27.7547 68.5303 24.9805C68.492 23.8189 68.7108 22.6473 69.1698 21.5344C70.6145 18.0694 74.0851 15.4734 77.7764 14.8197C80.0648 14.472 79.9515 11.2122 77.6331 11.0394C69.4951 10.6403 70.2169 2.18796 66.568 0.586246C64.7397 0.0229647 63.7773 3.86984 62.6992 5.00812C60.6995 8.31828 57.7383 10.8805 53.7745 11.2737C51.1258 11.7089 51.112 15.4583 53.7867 15.8903ZM66.6161 4.73859C68.0425 8.02312 70.0398 11.4723 73.4955 13.0152C70.5083 14.3214 67.9212 16.6045 66.3465 19.4736C65.1559 16.9152 63.1445 14.8544 60.7381 13.4206C63.5286 11.3942 65.3583 8.3589 66.6161 4.73859ZM31.2975 9.66171C33.637 10.047 35.5345 11.2725 35.6503 13.7248C35.7281 14.1102 36.0389 14.4605 36.4601 14.4672C38.0497 14.2142 37.6712 11.6406 38.7075 10.6905C39.2203 9.91906 43.2897 9.30281 42.0067 7.9839C40.9869 7.505 39.8231 7.22703 39.072 6.425C38.3687 5.68765 37.9789 4.30984 37.6983 3.48625C37.4258 2.4589 35.9419 2.42968 35.7001 3.48671C35.1244 5.70593 34.2094 6.66343 32.01 7.29593C31.3928 7.5025 30.5876 7.5914 30.4355 8.37453C30.3108 8.96828 30.7014 9.55 31.2975 9.66171Z"
                                fill="#444444"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1_8147">
                                <rect width={80} height={80} fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <h4 className="tp-catagori-2__title text-white">
                            Lightweight & Durable
                          </h4>
                          <p className="mb-0">
                            Designed to be long-lasting and easy to display,
                            wood prints offer a stylish alternative to
                            traditional framed artwork.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-6 col-md-6 col-sm-12">
                      <div className="tp-catagori-2__content-box ">
                        <div className="tp-catagori-2__content plr text-center">
                          <svg
                            width={80}
                            height={80}
                            viewBox="0 0 80 80"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_1_8147)">
                              <path
                                d="M78.8226 26.8516C78.7159 25.2068 76.4032 25.1141 76.1535 26.729C74.9785 35.1023 75.5162 43.6477 75.3029 52.0518C68.6352 44.2127 60.5882 37.4643 54.4332 29.2019C54.2289 28.9786 53.9442 28.8457 53.6419 28.8322C53.3395 28.8188 53.0442 28.9261 52.8209 29.1304C43.5917 37.5708 38.2585 49.2476 30.1337 58.6301C27.5974 55.6499 25.0242 52.6958 22.3351 49.8258C21.7773 49.1541 20.7137 49.1458 20.1574 49.824C17.6846 52.7826 15.4273 56.0279 13.1942 59.1618C12.4263 60.2974 13.9749 61.4924 14.8792 60.4677C16.6848 58.3191 19.0996 55.303 21.1823 52.9948C27.0398 60.126 32.3388 67.7357 38.1032 74.9712C28.1698 75.5648 18.2221 76.461 8.30962 75.5482C4.52259 74.7579 3.01759 70.9607 3.23853 67.4093C3.11728 62.2296 3.54212 57.1037 3.67166 51.9184C4.29119 51.5437 4.73931 50.8679 4.73916 49.8796C4.56119 42.0002 3.98587 34.0568 3.83728 26.1824C1.95041 15.4879 9.53791 11.9941 18.8627 14.3144C21.1596 14.3829 21.3835 11.1166 19.1059 10.8651C7.96072 9.35116 -1.12834 13.8246 0.488688 26.3583C0.293219 33.1051 0.476031 42.3718 0.00243768 49.7905C-0.0363123 50.7766 0.390875 51.471 1.00181 51.8698C0.864313 56.7244 0.356656 61.6062 0.398063 66.4862C-0.143969 71.8458 2.13634 77.543 7.95744 78.6344C22.0363 80.0423 36.2163 79.2373 50.3207 79.2674C59.399 79.4458 70.0907 79.7079 77.5018 73.604C78.7249 72.4591 77.2809 70.6251 75.8959 71.4683C68.1966 75.6058 58.9965 74.6552 50.5262 74.5399C48.3323 74.534 46.1368 74.5858 43.9401 74.673C39.7884 70.1497 35.846 65.3858 31.8809 60.6921C39.6559 51.9783 44.8851 41.3016 53.2818 33.1305C58.427 39.8901 64.4071 46.1115 69.8302 52.6271C71.6771 54.8766 73.7338 57.4899 75.4021 59.8785C76.6852 61.664 79.552 60.8679 79.7129 58.6515C80.622 48.2179 79.106 37.2794 78.8226 26.8516Z"
                                fill="#444444"
                              />
                              <path
                                d="M21.4303 39.5086C33.2915 40.412 33.1645 22.0348 21.5065 22.2528C10.8434 22.4519 10.9433 38.7992 21.4303 39.5086ZM16.137 31.0848C16.5448 24.7714 27.298 26.1778 26.6289 32.2636C26.6261 32.3944 26.5922 32.6531 26.5626 32.7806C25.3658 38.895 15.6787 37.1311 16.137 31.0848ZM53.7867 15.8903C57.4128 16.3861 61.0415 18.3953 62.7853 21.6786C63.2647 22.9941 63.7065 24.2623 64.0089 25.4953C64.519 28.1773 68.6314 27.7547 68.5303 24.9805C68.492 23.8189 68.7108 22.6473 69.1698 21.5344C70.6145 18.0694 74.0851 15.4734 77.7764 14.8197C80.0648 14.472 79.9515 11.2122 77.6331 11.0394C69.4951 10.6403 70.2169 2.18796 66.568 0.586246C64.7397 0.0229647 63.7773 3.86984 62.6992 5.00812C60.6995 8.31828 57.7383 10.8805 53.7745 11.2737C51.1258 11.7089 51.112 15.4583 53.7867 15.8903ZM66.6161 4.73859C68.0425 8.02312 70.0398 11.4723 73.4955 13.0152C70.5083 14.3214 67.9212 16.6045 66.3465 19.4736C65.1559 16.9152 63.1445 14.8544 60.7381 13.4206C63.5286 11.3942 65.3583 8.3589 66.6161 4.73859ZM31.2975 9.66171C33.637 10.047 35.5345 11.2725 35.6503 13.7248C35.7281 14.1102 36.0389 14.4605 36.4601 14.4672C38.0497 14.2142 37.6712 11.6406 38.7075 10.6905C39.2203 9.91906 43.2897 9.30281 42.0067 7.9839C40.9869 7.505 39.8231 7.22703 39.072 6.425C38.3687 5.68765 37.9789 4.30984 37.6983 3.48625C37.4258 2.4589 35.9419 2.42968 35.7001 3.48671C35.1244 5.70593 34.2094 6.66343 32.01 7.29593C31.3928 7.5025 30.5876 7.5914 30.4355 8.37453C30.3108 8.96828 30.7014 9.55 31.2975 9.66171Z"
                                fill="#444444"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1_8147">
                                <rect width={80} height={80} fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                          <h4 className="tp-catagori-2__title text-white">
                            Unique Home Décor Piece
                          </h4>
                          <p className="mb-0">
                            Add a modern yet timeless touch to your home with a
                            personalized wood print that turns memories into
                            beautiful wall art.
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* <div className="text-center mt-60 button-uper">
          <Link to={"/create-custom-print"} className="large head banner">
             Create WOOD PRINT</Link>
          </div> */}
                  </div>
                </div>
              </div>
            </div>
            {/* catagori-area-end */}
            {/* full container start */}
            <section className="full-section main">
              <div className="container">
                <div className="row ">
                  <div className="col-xl-6 col-lg-6 col-md-12 text">
                    <div className="bottom-para left pt-30 pb-30">
                      <h4>What is a Wood Print?</h4>
                      <p>
                        {" "}
                        A wood print transforms your favorite photograph into a
                        beautiful piece of natural artwork. Your image is
                        professionally printed directly onto a premium wood
                        surface, allowing the unique grain texture to add warmth
                        and character to every piece. The result is a modern,
                        rustic display that brings your memories to life.
                      </p>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-12">
                    <div className=" ">
                      <img
                        className="w-32"
                        src="assets/img/blog/mood-left.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-12">
                    <div className="image-top">
                      <img
                        className="w-32"
                        src="assets/img/blog/mood-right.png"
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-12 text">
                    <div className="bottom-para left pt-30 pb-30">
                      <h4>How Is a Wood Print Made?</h4>
                      <p>
                        Our wood prints are created using high-quality materials
                        and advanced printing techniques to deliver vibrant
                        colors and lasting detail. Each image is carefully
                        printed onto a smooth wood surface, inspected for
                        quality, and prepared to become a unique piece of wall
                        art for your home or office.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* full container end */}
            {/* Printlific Affiliate Partener section start */}
            <section
              className="pt-80 pb-80 Partener"
              data-background="assets/img/blog/wood-print-bg.png"
              style={{
                backgroundSize: "cover",
                backgroundImage: 'url("assets/img/breadcrumb/routing.png")',
              }}
            >
              <div className="container">
                <div className="row ">
                  <div className="col-xl-6 col-lg-6 col-md-12 text sec">
                    <div className="bottom-para left pt-30 pb-30 ">
                      <h4>Best Photos for Wood Prints</h4>
                      <p>
                        Wood prints work beautifully with images that capture
                        natural beauty, meaningful moments, and rich colors.
                        Family portraits, wedding memories, travel photographs,
                        and landscape images all look stunning when displayed on
                        wood, creating a warm and timeless piece of décor.
                      </p>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-12">
                    <div className=" ">
                      <img
                        className="w-32"
                        src="assets/img/blog/wood-prints.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {/* Printlific Affiliate Partener section end */}
          </div>
        )}

        <UpperFooterSlider />
      </main>

      {Loading ? (
        <div className="LoaderSpinner">
          <BounceLoader
            color={"#003bff"}
            loading={Loading}
            speedMultiplier={2}
            size={50}
          />
          <div>Loading... Please wait.</div>
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
